import PublicCreateBooking from './CreateBooking.vue'
import { PublicResourceDay } from 'dync-booking';

export default {
  install(Vue, options) {
    options = options || {};
    if (
      options.router
      && options.store.getters['dync-properties/get']('digierge', 'use_custom_thepot_web_booking')
    ) {
      options.router.addRoute({
        path: '/booking/create/:calendarId',
        name: 'public-create-booking',
        props: (route) => ({
          ...route.params,
          ...route.query
        }),
        component: PublicCreateBooking,
        meta: {
          public: true
        }
      });
      options.router.addRoute({
        path: '/booking/create-qr/:calendarId',
        name: 'public-create-booking-qr',
        props: (route) => ({
          ...route.params,
          resourceId: route.query.resourceIds,
          express: route.query.express,
          bookButton: true,
          createBookingRoute: 'public-create-booking',
          defaultColor: '#121212'
        }),
        component: PublicResourceDay,
        meta: {
          public: true
        }
      });
      options.router.addRoute({
        path: '/booking/calendar/:calendarId',
        name: 'public-booking-calendar',
        redirect: route => {
          return {
            name: 'booking-week',
            params: route.params
          }
        },
        props: true,
        meta: {
          public: true
        }
      });
      options.router.addRoute({
        path: '/resource-day/:resourceId',
        name: 'resource-day',
        props: (route) => ({
          ...route.params,
          calendarId: 'default',
          coloredBackground: true,
          defaultColor: '#121212'
        }),
        component: PublicResourceDay,
        meta: {
          public: true
        }
      });
    }
  }
};

export {
};
